import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../lib/firebase";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

export default function AdminApp() {
  const [user, setUser] = useState(undefined);

  useEffect(() => onAuthStateChanged(auth, setUser), []);

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[var(--color-bg-soft)]">
        <p className="text-navy/40">Loading…</p>
      </div>
    );
  }

  return user ? <AdminDashboard /> : <AdminLogin />;
}
